module.exports = __webpack_public_path__ + "static/media/GoK.88af2a15.png";